import { useState } from "react";

// Moving Google-reviews strip — kitchen-exhaust LP2 (paid-ads landing page) only.
// Twelve client-supplied branded review banners (each carries the "What Our
// Clients Say / Rated 4.9/5 on Google Reviews" header). Seamless right-to-left
// CSS marquee on the site's shared rail system; pauses on cursor hover
// (desktop), finger press (mobile) and keyboard focus. Reduced motion: static.
const ITEMS = [
  ["01", "Alexia Rodrigues"], ["02", "Bikram Behera"], ["03", "Bunty Budhrani"],
  ["04", "Neha Rane"], ["05", "Niral Pillewan"], ["07", "Sanjana Gowda"],
  ["08", "Vikram Shinde"], ["10", "Pragya Yadav"], ["11", "Pratik Jadhav"],
  ["12", "Shamshuddin Shamshu"],
  // removed per owner: 06 (Sana) and 09 (mislabelled file — duplicate Sanjana review)
].map(([num, name]) => ({
  src: `/assets/dcc/lp2-review-${num}.webp`,
  alt: `Google review by ${name} for Duct Clean Co. — rated 5 stars`,
}));

export function TestimonialsMarquee() {
  const [held, setHeld] = useState(false);
  return (
    <div
      className={`rail rail-mask ${held ? "rail-held" : ""}`}
      data-testid="testimonials-marquee"
      role="region"
      aria-label="Client Google reviews — moving strip, hold to pause"
      onTouchStart={() => setHeld(true)}
      onTouchEnd={() => setHeld(false)}
      onTouchCancel={() => setHeld(false)}
    >
      <div className="rail-track animate-marquee" style={{ animationDuration: "72s" }}>
        {[0, 1].map((copy) => (
          <div key={copy} className="rail-copy gap-5 pr-5" aria-hidden={copy === 1 || undefined}>
            {ITEMS.map((it, i) => (
              <figure
                key={it.src}
                className="w-[85vw] max-w-[340px] shrink-0 sm:w-[560px] sm:max-w-none"
                data-testid={copy === 0 ? `testimonial-item-${i + 1}` : undefined}
              >
                <img
                  src={it.src}
                  alt={copy === 0 ? it.alt : ""}
                  width="1200"
                  height="675"
                  loading="lazy"
                  decoding="async"
                  className="w-full border border-zinc-800"
                />
              </figure>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
